export default {
    isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.bottom >= 0
            && rect.right >= 0
            && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
            && rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
    initEach(items) {
        items.forEach((el) => {
            if (this.isInViewport(el) && !el.classList.contains('animate')) {
                el.classList.add('animate');
            }
        });
    },
    init() {
        const items = document.querySelectorAll('[data-animation]');
        this.initEach(items);
        document.addEventListener('scroll', () => {
            this.initEach(items);
        }, {
            passive: true,
        });
    },
};
